import React from 'react'
export default function () {
    return <h1>Table</h1>
}